export default function Footer() {
    try {
        return (
            <footer
                data-name="footer"
                data-file="components/Footer.js"
                className="bg-gray-800 text-gray-300 p-4"
            >
                <div className="container mx-auto px-4 flex flex-col md:flex-row justify-center items-center text-sm md:space-x-6">
                    <p className="mb-2 md:mb-0">
                        Powered by Miners Market
                    </p>
                    <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4">
                        <a href="mailto:support@minersmarket.co.za" className="text-gray-400 hover:text-white transition-colors">
                            <i className="fas fa-envelope mr-2"></i>support@minersmarket.co.za
                        </a>
                        <a href="tel:+27824551658" className="text-gray-400 hover:text-white transition-colors">
                            <i className="fas fa-phone mr-2"></i>+27 82 455 1658
                        </a>
                        <span className="hidden sm:inline text-gray-500">|</span>
                        <a href="/documents/footer/Miners Market Privacy Policy.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                            Privacy Policy
                        </a>
                        <span className="hidden sm:inline text-gray-500">|</span>
                        <a href="/documents/footer/Miners Market Terms of Use.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                            Terms of Use
                        </a>
                    </div>
                </div>
            </footer>
        );
    } catch (error) {
        console.error('Footer component error:', error);
        // reportError(error); // Assuming reportError is a global function or will be implemented
        return null; // Fallback UI in case of an error
    }
}
